import React from "react";
import SaleSubmissonForm from "./SaleSubmissionForm/SaleSubmissonForm";

const SaleSubmission = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <SaleSubmissonForm />
        </div>
      </div>
    </div>
  );
};

export default SaleSubmission;
